import { createRoutesView } from 'atomic-router-react';
import { AuthVerifyPage } from '../pages/auth-verify';
import { HomePage } from '../pages/home';
import { ProjectPage } from '../pages/project';
import { SharedPage } from '../pages/shared';
import { SignInPage } from '../pages/sign-in';
import { routes } from '../shared/routing';

export const RoutesView = createRoutesView({
  routes: [
    { route: routes.home, view: HomePage },
    { route: routes.project, view: ProjectPage },
    { route: routes.signIn, view: SignInPage },
    { route: routes.authVerify, view: AuthVerifyPage },
    { route: routes.shared, view: SharedPage },
  ],
});
